import { Component, OnInit } from '@angular/core';
import { VendorService } from '../../services/vendor.service';


@Component({
  selector: 'app-vendors',
  templateUrl: './vendors.component.html'
})
export class VendorsComponent implements OnInit {
  vendors: any[] = [];
  loading = true;

  constructor(private vendorsService: VendorService) { }

  ngOnInit(): void {
    this.loadVendors();
  }

  loadVendors() {
    this.vendorsService.getAllVendors().subscribe({
      next: (res) => {
        this.vendors = res;
        this.loading = false;
      },
      error: () => (this.loading = false)
    });
  }

  approveVendor(id: number) {
    this.vendorsService.approveVendor(id).subscribe(() => {
      this.loadVendors();
    });
  }

  rejectVendor(id: number) {
    this.vendorsService.rejectVendor(id).subscribe(() => {
      this.loadVendors();
    });
  }

  deleteVendor(id: number) {
    if (confirm('Are you sure you want to delete this vendor?')) {
      this.vendorsService.deleteVendor(id).subscribe(() => {
        this.loadVendors();
      });
    }
  }
}
